import React from 'react'
import styled, { withTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withRouter } from 'react-router-dom'
import priceSources, { CARD_MARKET, priceSourceParents } from '../../data/priceSources'
import Link from '../router/Link'
import { desktop } from '../../styles/media'
import { createAffiliateClick } from '../../state/actionCreators/app'

const PriceSourceLink = ({ button, createAffiliateClick, children, externalLink, location, priceSource, printId, settings, theme, userLanguage }) => {
	const data = priceSources[priceSourceParents[priceSource]]
	const to = data.buildLink(externalLink, userLanguage, settings)
	const dark = theme.id === 'dark'

	return (
		<StyledPriceSourceLink
			external
			externalNoIcon
			to={!button ? to : null}
			priceSource={priceSource}
			disabled={!externalLink}
			button={button}
			onClick={(event) => {
				if (button) {
					event.preventDefault()
				}

				event.stopPropagation()

				createAffiliateClick(priceSource, printId, location.pathname)

				if (button) {
					window.open(to)
				}
			}}
			as={button ? 'button' : undefined}
		>
			<img
				srcSet={dark ? `${data.logoColumnWhite1x} 1x, ${data.logoColumnWhite2x} 2x, ${data.logoColumnWhite3x} 3x` : `${data.logoColumn1x} 1x, ${data.logoColumn2x} 2x, ${data.logoColumn3x} 3x`}
				src={dark ? data.logoColumnWhite1x : data.logoColumn1x}
				alt={data.name}
			/>
			{children}
		</StyledPriceSourceLink>
	)
}

PriceSourceLink.propTypes = {
	createAffiliateClick: PropTypes.func.isRequired,
	button: PropTypes.bool,
	children: PropTypes.any,
	externalLink: PropTypes.string,
	location: PropTypes.object.isRequired,
	priceSource: PropTypes.number.isRequired,
	printId: PropTypes.number,
	settings: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	userLanguage: PropTypes.string.isRequired
}

PriceSourceLink.defaultProps = {
	button: false,
	children: null,
	externalLink: null,
	printId: null
}

export const StyledPriceSourceLink = styled(Link)`
	background: transparent;
	border: 0;
	cursor: pointer;
	padding: 0.15rem;
	transition: 0.1s;

	${props => !props.button && `
		border-radius: 4px;
		height: 33px;

		align-items: center;
		display: flex;
		justify-content: center;
	`}

	${props => props.button && `
		width: 100%;
	`}

	img {
		width: 28px;

		${props => props.button && props.priceSource === CARD_MARKET && `
			margin: 0 24px 0 9px !important;
		`}
	}

    ${props => props.disabled && `
    	cursor: default;
    	opacity: 0.5;

  		filter: grayscale(100%);
  		-webkit-transform: translateZ(0);
		-webkit-perspective: 1000;
		-webkit-backface-visibility: hidden;
  	`}

	${desktop`
		&:hover {
			${props => !props.button && `
				background: ${props.theme.background};
				box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
			`}
		}
	`}
`

const enhance = compose(
	connect(state => ({
		settings: state.persist.user.settings,
		userLanguage: state.persist.language
	}), dispatch => bindActionCreators({
		createAffiliateClick
	}, dispatch)),
	withRouter,
	withTheme
)

export default enhance(PriceSourceLink)
